import { Directive, ElementRef, Injector } from '@angular/core';
import { UpgradeComponent } from '@angular/upgrade/static';
import { ScopeProvider } from '../../../app/upgraded.providers';

@Directive({
  selector: 'app-admin',
  providers: [ScopeProvider],
})
export class AdminUpgradeDirective extends UpgradeComponent {
  constructor(elementRef: ElementRef, injector: Injector) {
    super('adminDirective', elementRef, injector);
  }
}
